module.exports = __webpack_public_path__ + "static/media/ios-refresh-circle.7f0494df.svg";